export default __webpack_public_path__ + "static/media/Slide18.b24fd1bb.PNG";